export default {
  from: {
    id: 'from',
    defaultMessage: 'From',
  },
  new: {
    id: 'card_new_keyword',
    defaultMessage: 'new',
  },
}
